import { ragApi } from './ApiService'

export interface RuntimeTimelineEvent {
  schema_version?: string
  event_type: string
  timestamp: string
  trace_id: string
  conversation_id?: string | null
  turn_id?: string | null
  tenant_id?: string | null
  agent_id?: string | null
  provider?: string | null
  model?: string | null
  tool_name?: string | null
  status?: string | null
  error_type?: string | null
  latency_ms?: number | null
  input_tokens?: number | null
  output_tokens?: number | null
  total_tokens?: number | null
  cost_usd_estimate?: number | null
  pricing_source?: string | null
  usage_status?: string | null
  payload?: Record<string, unknown>
  log_id?: string
  log_created_at?: string
}

export interface RuntimeTimelineResponse {
  count: number
  filters: Record<string, unknown>
  results: RuntimeTimelineEvent[]
}

export interface RuntimeTimelineSummaryRow {
  group_key: string
  provider: string | null
  model: string | null
  calls: number
  error_count: number
  error_rate_pct: number
  total_cost_usd: number
  total_input_tokens: number
  total_output_tokens: number
  total_tokens: number
  avg_latency_ms: number | null
  pricing_sources: string[]
  pricing_versions: string[]
  usage_status_counts: Record<string, number>
}

export interface RuntimeTimelineSummaryResponse {
  count: number
  group_by: 'provider_model' | 'provider' | 'model'
  filters: Record<string, unknown>
  results: RuntimeTimelineSummaryRow[]
}

// `type` y no `interface` a proposito: se pasa como `params` a ragApi.get, que
// espera Record<string, unknown>, y TypeScript solo da indice implicito a los
// alias de tipo. Con `interface` no compila, que es el error TS2322 que CI no
// veia.
export type RuntimeTimelineFilters = {
  trace_id?: string
  conversation_id?: string
  turn_id?: string
  tenant_id?: string
  provider?: string
  model?: string
  status?: string
  error_type?: string
  date_from?: string
  date_to?: string
  min_cost_usd?: number
  max_cost_usd?: number
  limit?: number
}

class ObservabilityService {
  async getTimeline(filters: RuntimeTimelineFilters): Promise<RuntimeTimelineResponse> {
    const response = await ragApi.get('/api/mcp/logs/timeline/', { params: filters }) as RuntimeTimelineResponse
    return {
      count: Number(response?.count || 0),
      filters: response?.filters || {},
      results: Array.isArray(response?.results) ? response.results : [],
    }
  }

  async getTimelineSummary(
    filters: RuntimeTimelineFilters & { group_by?: 'provider_model' | 'provider' | 'model' }
  ): Promise<RuntimeTimelineSummaryResponse> {
    const response = await ragApi.get('/api/mcp/logs/timeline-summary/', { params: filters }) as RuntimeTimelineSummaryResponse
    return {
      count: Number(response?.count || 0),
      group_by: (response?.group_by || 'provider_model') as RuntimeTimelineSummaryResponse['group_by'],
      filters: response?.filters || {},
      results: Array.isArray(response?.results) ? response.results : [],
    }
  }
}

export const observabilityService = new ObservabilityService()
